import he from 'he'

export default he.decode
